/**
 * Returns the post-login landing path based on the user's role.
 *
 * Used after login, OTP verification, and accept-invite flows.
 * Keeps role→landing mapping in one place — update here when adding
 * new portal routes (e.g. partner portal).
 *
 * Guardians now use the separate React parent portal (parent.routr.com),
 * so they no longer land in Vue.
 */
export function getLandingPath() {
  return '/tools/contracts/all'
}
